<template>
  <div class="man-pages">
    <div class="page-header">
      <h2 class="title"><i class="el-icon-document"></i> Linux Man Pages 命令手册在线查询</h2>
      <p class="subtitle">支持 1-9 章节 · 快速查阅命令用法与参数。试试 ls、grep、nginx 等常用命令</p>
    </div>

    <el-card class="search-card" shadow="never">
      <el-form :model="form" inline>
        <el-form-item label="命令">
          <el-input v-model="form.command" @input="validateInput" required></el-input>
        </el-form-item>
        <el-form-item label="章节">
          <el-select v-model="form.section" placeholder="Select" style="min-width: 6rem">
            <el-option label="Auto" value="auto"></el-option>
            <el-option v-for="section in sections" :key="section" :label="`${section}`" :value="section"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="语言">
          <el-select v-model="form.language" placeholder="Select" style="min-width: 6rem">
            <el-option label="英文" value="en"></el-option>
            <el-option label="中文简体" value="zh"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" :loading="loading">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <div v-if="result" style="margin-top: 20px">
      <pre class="man-result">{{ result }}</pre>
    </div>
    <div v-if="error" style="margin-top: 20px; color: red">{{ error }}</div>
  </div>
</template>

<script>
import axios from "axios";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      form: {
        command: "uptime",
        section: "auto",
        language: "en",
      },
      sections: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      result: "",
      error: "",
      loading: false,
    };
  },
  methods: {
    validateInput(value) {
      // 使用正则表达式替换不允许的字符
      //   ElMessage.error("存在非法字符");
      this.form.command = value.replace(/[$()`]/g, "");
    },
    async search() {
      const cmd = (this.form.command || "").trim();
      if (!cmd) {
        this.result = "";
        this.error = "请输入命令";
        ElMessage({ message: "请输入命令", type: "warning", duration: 3000, offset: 240 });
        return;
      }

      try {
        this.loading = true;
        const response = await axios.get(`/api/man/`, { params: { ...this.form } });
        this.result = Array.isArray(response.data) ? response.data.join("\n") : response.data;
        this.error = "";
      } catch (error) {
        this.result = "";
        if (error.response?.status === 404) {
          ElMessage({ message: "未找到该命令的帮助手册", type: "warning", duration: 3000, offset: 240 });
          this.error = "请检查输入，该命令【" + this.form.command + "】不存在或未安装帮助手册";
        } else {
          ElMessage({ message: "手册查询服务暂时不可用，请稍后重试", type: "error", duration: 3000, offset: 240 });
          this.error = "查询服务暂时出现异常，这不代表命令【" + this.form.command + "】不存在。";
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.man-pages {
  padding: 32px;
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
}

.page-header {
  margin-bottom: 24px;
}

.title {
  margin: 0 0 8px;
  font-size: 24px;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 12px;
}

.subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}

.search-card {
  margin-bottom: 24px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.search-card :deep(.el-card__body) {
  padding: 20px;
}

.man-result {
  text-align: left;
  white-space: pre-wrap;
  font-family: "Fira Code", "Consolas", "Courier New", monospace;
  background-color: #1e1e1e;
  color: #d4d4d4;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #333;
  line-height: 1.5;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  overflow-x: auto;
}

/* 模拟终端滚动条 */
.man-result::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.man-result::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 4px;
}

.man-result::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
